import { createReducer } from "reduxsauce";

//Custom Imports
import { contestType } from "./actionTypes";
import {
  getApiInitialState,
  apiFetchedState,
  getInitialPendingState,
} from "@actions/redux.action";

const initialState = {
  liveUpcoming: {
    data: [],
    api: getInitialPendingState(),
  },
  pastContest: {
    data: [],
    api: getInitialPendingState(),
  },
  contestDetails: {
    data: {},
    api: getInitialPendingState(),
  },
  myCustomers: {
    data: {
      contestLeaderCustomers: [],
      orderedCx: 0,
      totalCx: 0,
    },
    api: getInitialPendingState(),
  },
  contestCxOrdered: {
    data: {
      contestLeaderCustomers: [],
    },
    api: getInitialPendingState(),
  },
  moreCustomerLoading: false,
  moreOrderedCustLoading: false,
};

const setSuccessStatus = (key, newStatus) => (state, action) => ({
  ...state,
  [key]: {
    ...state[key],
    data: action.payload,
    api: apiFetchedState(newStatus, state[key].api),
  },
});

const setStatus = (key, newStatus) => (state) => ({
  ...state,
  [key]: {
    ...state[key],
    api: apiFetchedState(newStatus, state[key].api),
  },
});

const setSingleValue = (key) => (state, action) => ({
  ...state,
  [key]: action.payload,
});

const actionHandlers = {
  [contestType.GET_LIVE_UPCOMING]: setStatus("liveUpcoming", { pending: true }),
  [contestType.GET_LIVE_UPCOMING_SUCCESS]: setSuccessStatus("liveUpcoming", {
    success: true,
  }),
  [contestType.GET_LIVE_UPCOMING_ERROR]: setStatus("liveUpcoming", {
    error: true,
  }),
  [contestType.GET_LIVE_UPCOMING_FETCHED]: setStatus("liveUpcoming", {
    fetched: true,
  }),

  [contestType.GET_PAST_CONTEST]: setStatus("pastContest", { pending: true }),
  [contestType.GET_PAST_CONTEST_SUCCESS]: setSuccessStatus("pastContest", {
    success: true,
  }),
  [contestType.GET_PAST_CONTEST_ERROR]: setStatus("pastContest", {
    error: true,
  }),
  [contestType.GET_PAST_CONTEST_FETCHED]: setStatus("pastContest", {
    fetched: true,
  }),

  [contestType.GET_CONTEST_DETAILS]: setStatus("contestDetails", {
    pending: true,
  }),
  [contestType.GET_CONTEST_DETAILS_SUCCESS]: setSuccessStatus(
    "contestDetails",
    { success: true },
  ),
  [contestType.GET_CONTEST_DETAILS_ERROR]: setStatus("contestDetails", {
    error: true,
  }),
  [contestType.GET_CONTEST_DETAILS_FETCHED]: setStatus("contestDetails", {
    fetched: true,
  }),

  [contestType.GET_MY_CUSTOMERS]: setStatus("myCustomers", { pending: true }),
  [contestType.GET_MY_CUSTOMERS_SUCCESS]: setSuccessStatus("myCustomers", {
    success: true,
  }),
  [contestType.GET_MY_CUSTOMERS_ERROR]: setStatus("myCustomers", {
    error: true,
  }),
  [contestType.GET_MY_CUSTOMERS_FETCHED]: setStatus("myCustomers", {
    fetched: true,
  }),

  [contestType.GET_CONTEST_CX_ORDERED]: setStatus("contestCxOrdered", {
    pending: true,
  }),
  [contestType.GET_CONTEST_CX_ORDERED_SUCCESS]: setSuccessStatus(
    "contestCxOrdered",
    { success: true },
  ),
  [contestType.GET_CONTEST_CX_ORDERED_ERROR]: setStatus("contestCxOrdered", {
    error: true,
  }),
  [contestType.GET_CONTEST_CX_ORDERED_FETCHED]: setStatus("contestCxOrdered", {
    fetched: true,
  }),

  [contestType.MORE_CUSTOMERS_LOADING]: setSingleValue("moreCustomerLoading"),
  [contestType.MORE_ORDERED_CUSTOMERS_LOADING]: setSingleValue(
    "moreOrderedCustLoading",
  ),
};

export default createReducer(initialState, actionHandlers);
